import React from "react";
import { Wrapper, Header } from "./Table.styled";
import { Button } from "..";

export const Table = ({
  dataSource,
  columns,
  pagination,
  onChange,
  header,
  headerTitle,
  button,
  button1,
  button2,
  loading,
  className,
}) => {
  return (
    <>
      {header && (
        <Header>
          <div className="header">
            <h3 className="heading">{headerTitle}</h3>

            {button && (
              <div className="buttons">
                <div> {button1}</div>
                <div>{button2}</div>
              </div>
            )}
          </div>
        </Header>
      )}
      <Wrapper
        className={className}
        dataSource={dataSource}
        columns={columns}
        pagination={pagination}
        onChange={onChange}
        loading={loading}
      />
    </>
  );
};
